import clsx, { type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export type ClassName = ClassValue;

const identity = (strings: TemplateStringsArray, ...values: Array<unknown>): string =>
  String.raw({ raw: strings }, ...values);

export const tw = (strings: TemplateStringsArray, ...values: Array<unknown>): string =>
  twMerge(clsx(identity(strings, ...values)));

export const twx = (...classLists: Array<ClassValue>): string => twMerge(clsx(...classLists));
